import classNames from "classnames";
import styles from "./index.module.scss"
import { Row, Col, Form, Input, Button, Checkbox, Select } from 'antd';
import { country } from "@/apis/user"
import { useEffect, useState } from "react";
import intl from "react-intl-universal";

const ContactForm = () => {
	const { Option } = Select;
	const { TextArea } = Input;
	const msg = "Please complete this required field."
	const [countryList, setCountryList] = useState([])

	// 获取国家
	const getSelectList = () => {
		// 国家下拉
		country().then(res => {
			setCountryList(res.data || [])
		}).catch(err => { })
	}

	useEffect(() => {
		getSelectList()
	}, [])


	const onFinish = (values) => {
		console.log('Success:', values);
	};
	return <div className={classNames('container', styles.contactFormBox)}>
		{/* <h4>{intl.get("About.FOR GENERAL INQUIRIES,PLEASE USE THIS FORM")}</h4> */}

		<h1>{intl.get("About.Interested in becoming a member?")}</h1>
		<p>{intl.get("About.memberDes")}<a href="#">{intl.get("About.OGE Alliance Training & Certification team")}</a></p>
		<Form
			name="basic"
			onFinish={onFinish}
			autoComplete="off"
			layout="vertical"
			style={{ width: "66%" }}
			size="large"
			variant="filled"
		>
			<Row gutter={40}>
				<Col span={12}>
					<Form.Item
						label={intl.get("Register.Nickname")}
						name="a"
						rules={[
							{
								required: true,
								message: intl.get(msg)
							},
						]}
					>
						<Input maxLength={30}/>
					</Form.Item>
				</Col>
				{/* <Col span={12}>
					<Form.Item
						label={intl.get("Register.Last name")}
						name="b"
						rules={[
							{
								required: true,
								message: intl.get(msg)
							},
						]}
					>
						<Input />
					</Form.Item>
				</Col> */}

				<Col span={12}>
					<Form.Item
						label={intl.get("Email")}
						name="c"
						rules={[
							{
								required: true,
								message: intl.get(msg)
							}, {
								type: 'email',
								message: "Email must be formatted correctly."
							}
						]}
					>
						<Input />
					</Form.Item>
				</Col>

				<Col span={12}>
					<Form.Item
						label={intl.get("Register.Phone number")}
						name="d"
					>
						<Input />
					</Form.Item>
				</Col>

				<Col span={12}>
					<Form.Item
						label={intl.get("Register.Country/Region")}
						name="e"
					>
						<Select
							allowClear
							showSearch
						>
							{countryList.map(item => <Option key={item} value={item}>{item}</Option>)}
						</Select>
					</Form.Item>
				</Col>

				<Col span={12}>
					<Form.Item
						label={intl.get("Register.Company name")}
						name="f"
						rules={[
							{
								required: true,
								message: intl.get(msg)
							},
						]}
					>
						<Input />
					</Form.Item>
				</Col>

				<Col span={12}>
					<Form.Item
						label={intl.get("Register.Job title")}
						name="g"
					>
						<Input />
					</Form.Item>
				</Col>

				<Col span={24}>
					<Form.Item
						label={intl.get("Register.Topic")}
						name="h"
						rules={[
							{
								required: true,
								message: intl.get(msg)
							},
						]}
					>
						<Input />
					</Form.Item>
				</Col>

				<Col span={24}>
					<Form.Item
						label={intl.get("Register.Message")}
						name="i"
						rules={[
							{
								required: true,
								message: intl.get(msg),
							},
						]}
					>
						<TextArea rows={2} />
					</Form.Item>
				</Col>

				<Col span={24}>
					<Form.Item
						name="agreement"
						valuePropName="checked"
						rules={[
							{
								validator: (_, value) =>
									value ? Promise.resolve() : Promise.reject(new Error(
										intl.get('Should accept agreement')
									)),
							},
						]}
					>
						<Checkbox>
							{intl.get("Register.contactDes")}
						</Checkbox>
					</Form.Item>
				</Col>

			</Row>

			<Form.Item>
				<Button type="primary" htmlType="submit">
					{intl.get("Register.SUBMIT")}
				</Button>
			</Form.Item>

		</Form>
	</div>
}
export default ContactForm